import Project from '../project/project.model';
import User from '../user/user.model';

export default class TicketAttribute {
    public id = '';
    public name = '';
    public project: Project = new Project();
    public possibleValues: string[] = [];
    public otherEnabled = 0;
    public createdAt: Date = new Date();
    public createdBy: User = new User();
    public multi: boolean = false;
    public isDate: boolean = false;
    public auto: boolean = false;
    public searchable: boolean = false;
    public ticketAttributeExtensions: { externalLayer: { url: string }, argisAttributeName: string }[] = [];
    public isArcgis = false;
    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = model.id;
        }
        if (model._id) {
            this.id = model._id;
        }
        if (model.name) {
            this.name = model.name;
        }
        if (model.project) {
            this.project = new Project(model.project);
        }
        if (model.possibleValues) {
            this.possibleValues = model.possibleValues;
        }
        if (model.otherEnabled) {
            this.otherEnabled = model.otherEnabled;
        }
        if (model.createdAt) {
            this.createdAt = new Date(model.createdAt);
        }
        if (model.createdBy) {
            this.createdBy = new User(model.createdBy);
        }
        if (model.multi) {
            this.multi = model.multi;
        }
        if (model.isDate) {
            this.isDate = model.isDate;
        }
        if (model.auto) {
            this.auto = model.auto;
        }
        if (model.searchable) {
            this.searchable = model.searchable;
        }
        if (model.ticketAttributeExtensions) {
            this.ticketAttributeExtensions = model.ticketAttributeExtensions;
        }
        if (model.isArcgis) {
            this.isArcgis = model.isArcgis;
        }
    }
}
